// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"63":"edc9fa1e","253":"b0a05735","343":"91242609","520":"2a69ea5c","533":"574866ea"}[chunkId] + ".css";
};